import { 
    Component, 
    ViewChild 
}                                       from "@angular/core";
import {
    Router,
    ActivatedRoute
}                                       from "@angular/router";
import { 
    FormBuilder, 
    Validators 
}                                       from "@angular/forms";

import "style-loader!./503.scss";

@Component({
  selector: "error-503",
  template: require('./503.component.html'),
})
export class Error503Component {
    constructor(
      public router: Router,
      public route: ActivatedRoute 
      
    ) {
    }

    onLogoutClick() {
        this.router.navigate(["/login"]);
        return false;
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/screens/errors/503.component.ts